import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export const Solution = () => {
  return <section className="py-20 bg-legal-800 relative overflow-hidden" data-id="element-256">
      {/* Decorative scale background */}
      <div className="absolute -right-20 -top-20 text-legal-700/20 pointer-events-none" data-id="element-257">
        <Scale className="w-96 h-96" data-id="element-258" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-259">
        <div className="max-w-3xl mx-auto text-center" data-id="element-260">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-261">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/10 mb-6" data-id="element-262">
              <Scale className="w-8 h-8 text-gold-500" data-id="element-263" />
            </div>

            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-264">
              Presentamos el sistema definitivo para{' '}
              <span className="text-gold-500" data-id="element-265">abogados.</span>
            </h2>

            <p className="text-lg md:text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-266">
              Es una <strong data-id="element-267">biblioteca profesional</strong> diseñada para que
              cualquier abogado pueda trabajar con mayor rapidez, seguridad y
              respaldo profesional.
            </p>

            <div className="h-1 w-24 bg-gold-500 mx-auto rounded-full" data-id="element-268"></div>
          </motion.div>
        </div>
      </div>
    </section>;
};